import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const CheckoutWrapper = lazy(
  () => import('@/modules/Checkout/pages/CheckoutWrapper'),
)

const AttendanceRecurrence = lazy(
  () => import('@/modules/Checkout/pages/AttendanceRecurrence'),
)

const AttendanceRecurrenceResult = lazy(
  () => import('@/modules/Checkout/pages/AttendanceRecurrenceResult'),
)

const CheckoutRoutes = [
  <RequireAuthentication
    exact
    path="/checkout/:step"
    key="/checkout/"
    component={CheckoutWrapper}
  />,
  <RequireAuthentication
    exact
    path="/checkout/:step/:type"
    key="/checkout/"
    component={CheckoutWrapper}
  />,
  <RequireAuthentication
    exact
    path="/atendimento-recorrente/:attendanceId"
    key="/atendimento-recorrente/:attendanceId"
    component={AttendanceRecurrence}
  />,
  <RequireAuthentication
    exact
    path="/atendimento-recorrente/:attendanceId/resultado"
    key="/atendimento-recorrente/:attendanceId/resultado"
    component={AttendanceRecurrenceResult}
  />,
]

export default CheckoutRoutes
